import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (!args) {
      return value;
    } else {
      const searchTerm = args.toLowerCase();
      return value.filter((item) => {
        const containedInTitle = item.title.toLowerCase().indexOf(searchTerm) > -1;
        // let containedInTags = item.tags.find(tag => tag.toLowerCase().indexOf(searchTerm) > -1);
        return containedInTitle;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/search.pipe.ts